export function getImageHashFromUrl(url: string): string {
  return url.split('/').pop();
}
